import User   from './user';
import Issues from './issues';
import Issue  from './issue';
import Comment from './comment';
import RestAPI from './rest';

async function getUser() {
    try {
        const user    = new User();
        const respone = await user.fetch( user.query() );
        const result  = await respone.json();
        user.data     = result.data;
        return new Promise(( resolve, reject ) => {
            if ( result ) {
                resolve( user );
            } else {
                reject( result );
            }
        });
    } catch ( error ) {
        return new Promise(( resolve, reject ) => reject( error ));
    }
}

async function getIssues( page, search ) {
    try {
        const issues  = new Issues();
        const respone = await issues.fetch( issues.query( page, search ));
        const result  = await respone.json();
        issues.data   = result.data;
        return new Promise(( resolve, reject ) => {
            if ( result ) {
                resolve( issues );
            } else {
                reject( result );
            }
        });
    } catch ( error ) {
        return new Promise(( resolve, reject ) => reject( error ));
    }
}

async function getIssue( num ) {
    try {
        const issue   = new Issue();
        const respone = await issue.fetch( issue.query( num ));
        const result  = await respone.json();
        issue.data    = result.data;
        return new Promise(( resolve, reject ) => {
            if ( result ) {
                resolve( issue );
            } else {
                reject( result );
            }
        });
    } catch ( error ) {
        return new Promise(( resolve, reject ) => reject( error ));
    }
}

/**
 * Get Comments
 * 
 * @param {string} issues number
 * @param {string} endCursor when undefind is first; 
 * 
 * @returns {Promise}
 */
async function getComments( num, page ) {
    try {
        const issue   = new Issue();
        const respone = await issue.fetch( issue.queryComments( num, page ));
        const result  = await respone.json();
        issue.data    = result.data;
        return new Promise(( resolve, reject ) => {
            if ( result ) {
                resolve( issue );
            } else {
                reject( result );
            }
        });
    } catch ( error ) {
        return new Promise(( resolve, reject ) => reject( error ));
    }
}

async function addComment( content ) {
    try {
        const issue    = new Issue();
        const iss_res  = await issue.fetch( issue.getId( issue.memos ));
        const iss_data = await iss_res.json();
        const issueId  = iss_data.data.repository.issue.id;
        const comment  = new Comment();
        const cmm_res  = await comment.fetch( comment.add( issueId, content ));
        const result   = await cmm_res.json();
        return new Promise(( resolve, reject ) => {
            if ( result ) {
                resolve( result );
            } else {
                reject( result );
            }
        });
    } catch ( error ) {
        return new Promise(( resolve, reject ) => reject( error ));
    }
}

async function createIssue( title, body, labels ) {
    try {
        const rest     = new RestAPI();
        const respone  = await rest.createIssue( title, body, labels );
        const result   = await respone.json();
        return new Promise(( resolve, reject ) => {
            if ( result ) {
                resolve( result );
            } else {
                reject( result );
            }
        });
    } catch ( error ) {
        return new Promise(( resolve, reject ) => reject( error ));
    }
}

module.exports = {
    getUser, getIssues, getIssue, getComments, addComment, createIssue
};